var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_c('p',[_vm._v("Copyright @2022 客维智能科技（广州）有限公司 版权所有")]),_c('p',[_vm._v("粤ICP备11053761号-5")])])])
}]

export { render, staticRenderFns }